/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 */
import React, { Component } from 'react';
import WhatShot from 'material-ui/svg-icons/social/whatshot';
import RFC from 'material-ui/svg-icons/communication/vpn-key';
import { TextField } from 'material-ui';
import Filter from './filter';
import { EditableInline } from '../../components/text';
import Container from './container';
import {
    DropDownSearch,
    RemoteDropDownSearch,
    RemoteCheckboxGroup
} from '../../components/data-containers';
import { extractProperty } from '../../common/helpers';

const filter = {
    customsNumber: '',
    section: '',
    name: ''
};

class FilterContainer extends Component {

      constructor(props) {
          super(props);
          this.state = { ...filter };
      }


      updateValue = (path, value) => {
          this.setState({ [path]: value });
      };

    render() {
        const { children, onSearch, onClear } = this.props;
        const { customsNumber, section, name } = this.state;

        return (
            <Container
                contents={children}
                onSearch={() => onSearch(this.state)}
                onClear={() => {
                  this.setState({ ...filter})
                  onClear(this.state);
                }}
            >
                <Filter icon={<WhatShot />} title="Aduana" id="aduana">
                    <TextField
                        hintText="Aduana"
                        fullWidth
                        value={name}
                        onChange={(event, value) => this.updateValue('name', value)}
                    />
                </Filter>
                <Filter icon={<RFC />} title="Numero Aduana" id="numeroaduana">
                    <TextField
                        type="number"
                        hintText="Numero Aduana"
                        fullWidth
                        value={customsNumber}
                        onChange={(event, value) => this.updateValue('customsNumber', value)}
                    />
                </Filter>
                <Filter icon={<WhatShot />} title="Seccion" id="seccion">
                    <TextField
                        type="number"
                        hintText="Seccion"
                        fullWidth
                        value={section}
                        onChange={(event, value) => this.updateValue('section', value)}
                    />
                </Filter>
            </Container>
        );
    }
}

export default FilterContainer;



// WEBPACK FOOTER //
// ./components/filters/aduanas.js